import { RadioGroup, Radio } from "@sportal/cdk";
import "./Radio.scss";

export { RadioGroup, Radio };
